
(function () {
  function init(root) {
    if (!root || root.__ldu) return;
    root.__ldu = true;
    var vp = root.querySelector('[data-ldu-viewport]');
    var track = root.querySelector('[data-ldu-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ldu-card]'));
    var modal = root.querySelector('[data-ldu-modal]');
    var old = document.getElementById(modal.id);
    if (old && old !== modal) old.remove();
    document.body.appendChild(modal); // hors de la section : aucun parent du thème ne peut la masquer
    var stage = modal.querySelector('[data-ldu-stage]');
    var big = modal.querySelector('[data-ldu-big]');
    var soundBtn = modal.querySelector('[data-ldu-sound]');
    var prog = modal.querySelector('[data-ldu-progress]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var speed = (parseFloat(root.getAttribute('data-speed')) || 30); // pixels par seconde
    var hover = false, touch = false, open = null, visible = false, idleUntil = 0;
    var pos = 0, last = 0, setW = 0, raf = 0;

    function measure() {
      var clones = track.querySelectorAll('[data-ldu-clone]');
      if (!clones.length) { setW = 0; return; }
      setW = clones[0].offsetLeft - track.firstElementChild.offsetLeft;
    }
    function wrap() {
      if (setW > 0) {
        if (vp.scrollLeft >= setW) vp.scrollLeft -= setW;
        else if (vp.scrollLeft <= 0) vp.scrollLeft += setW;
      }
    }
    function paused() { return reduce || hover || touch || open || !visible || performance.now() < idleUntil; }
    function tick(t) {
      raf = requestAnimationFrame(tick);
      var dt = last ? Math.min(t - last, 64) : 16; last = t;
      if (paused()) { pos = vp.scrollLeft; return; }
      pos += speed * dt / 1000;
      if (setW > 0 && pos >= setW) pos -= setW;
      vp.scrollLeft = pos;
    }

    // Lecture muette des vignettes visibles uniquement (480p), chargement à l'approche de l'écran.
    var vidIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var card = e.target, v = card.querySelector('video');
        if (e.isIntersecting && !open) {
          if (!v.src) { v.src = card.getAttribute('data-low'); }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
          v.onplaying = function () { card.classList.add('is-live'); };
        } else if (!v.paused) { v.pause(); }
      });
    }, { root: vp, rootMargin: '0px 60px', threshold: 0.35 });

    var secIO = new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (visible) { cards.forEach(function (c) { vidIO.observe(c); }); }
      else { cards.forEach(function (c) { vidIO.unobserve(c); var v = c.querySelector('video'); if (!v.paused) v.pause(); }); }
    }, { rootMargin: '200px 0px' });
    secIO.observe(root);

    // Pause au survol (ordinateur) et au toucher (mobile) ; reprise douce ensuite.
    vp.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    vp.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; pos = vp.scrollLeft; } });
    vp.addEventListener('touchstart', function () { touch = true; }, { passive: true });
    vp.addEventListener('touchend', function () { touch = false; idleUntil = performance.now() + 1800; pos = vp.scrollLeft; }, { passive: true });
    vp.addEventListener('touchcancel', function () { touch = false; idleUntil = performance.now() + 1800; }, { passive: true });
    vp.addEventListener('wheel', function () { idleUntil = performance.now() + 1500; }, { passive: true });
    vp.addEventListener('scroll', function () { wrap(); if (paused()) pos = vp.scrollLeft; }, { passive: true });

    // Glisser à la souris sur ordinateur (le clic reste un clic sous 6 px de déplacement).
    var dragX = 0, dragS = 0, dragging = false, moved = false;
    vp.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true; moved = false; dragX = e.clientX; dragS = vp.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - dragX;
      if (!moved && Math.abs(dx) > 6) { moved = true; vp.classList.add('is-drag'); }
      if (moved) { vp.scrollLeft = dragS - dx; wrap(); pos = vp.scrollLeft; }
    });
    window.addEventListener('pointerup', function () {
      if (!dragging) return;
      dragging = false;
      if (moved) { idleUntil = performance.now() + 1200; setTimeout(function () { vp.classList.remove('is-drag'); moved = false; }, 0); }
    });

    // Ouverture : la vignette s'agrandit jusqu'au centre (animation FLIP) et la vidéo démarre avec le son.
    function flipFrom(rect) {
      var s = stage.getBoundingClientRect();
      var sx = rect.width / s.width, sy = rect.height / s.height;
      return 'translate(' + (rect.left - s.left) + 'px,' + (rect.top - s.top) + 'px) scale(' + sx + ',' + sy + ')';
    }
    function animate(from, to, done) {
      if (reduce || !stage.animate) { done && done(); return; }
      var a = stage.animate([{ transform: from, borderRadius: '16px' }, { transform: to, borderRadius: '20px' }],
        { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1)' });
      a.onfinish = function () { done && done(); };
    }
    function openCard(card) {
      if (open) return;
      open = card;
      cards.forEach(function (c) { var v = c.querySelector('video'); if (!v.paused) v.pause(); });
      var rect = card.getBoundingClientRect();
      big.poster = card.getAttribute('data-poster');
      big.src = card.getAttribute('data-hd');
      big.muted = false; soundBtn.classList.remove('is-muted');
      var small = card.querySelector('video');
      if (small && small.currentTime > 0.2 && small.src) { try { big.currentTime = small.currentTime; } catch (e) {} }
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var p = big.play(); if (p && p.catch) p.catch(function () { big.muted = true; soundBtn.classList.add('is-muted'); big.play(); });
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
        animate(flipFrom(rect), 'none');
        modal.querySelector('.ldu__x').focus({ preventScroll: true });
      });
    }
    function closeModal() {
      if (!open) return;
      var card = open, rect = card.getBoundingClientRect();
      modal.classList.remove('is-open');
      big.muted = true;
      animate('none', flipFrom(rect), function () {
        big.pause(); big.removeAttribute('src'); big.load();
        modal.hidden = true;
        document.documentElement.style.overflow = '';
        open = null; pos = vp.scrollLeft; idleUntil = performance.now() + 600;
        try { card.focus({ preventScroll: true }); } catch (e) {}
        cards.forEach(function (c) { vidIO.unobserve(c); vidIO.observe(c); });
      });
    }
    cards.forEach(function (c) {
      c.addEventListener('click', function (e) { if (moved) { e.preventDefault(); return; } openCard(c); });
    });
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-ldu-close]')) closeModal(); });
    soundBtn.addEventListener('click', function () { big.muted = !big.muted; soundBtn.classList.toggle('is-muted', big.muted); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    big.addEventListener('timeupdate', function () { if (big.duration) prog.style.transform = 'scaleX(' + (big.currentTime / big.duration) + ')'; });
    stage.addEventListener('click', function (e) {
      if (e.target === big) { if (big.paused) big.play(); else big.pause(); }
    });

    function start() { measure(); vp.scrollLeft = 1; pos = 1; cancelAnimationFrame(raf); last = 0; raf = requestAnimationFrame(tick); }
    window.addEventListener('resize', function () { measure(); wrap(); });
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
    root.__lduStop = function () { cancelAnimationFrame(raf); vidIO.disconnect(); secIO.disconnect(); modal.remove(); document.documentElement.style.overflow = ''; };
  }

  function boot() { document.querySelectorAll('[data-ldu]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-ldu]'); if (r) init(r); });
  document.addEventListener('shopify:section:unload', function (e) { var r = e.target.querySelector('[data-ldu]'); if (r && r.__lduStop) r.__lduStop(); });
})();
